<div
  class="unit-item"
  (click)="openUnitPortal()"
  tabindex="0"
  (keydown.enter)="openUnitPortal()"
>
  <div class="unit-content">
    <mat-icon svgIcon="scale-balance"></mat-icon>
    <span class="name">
      {{ getUnitLabel(selectedUnit()) | translate }}
    </span>
    <mat-icon class="arrow-icon">
      {{ isUnitDropdownOpen() ? "keyboard_arrow_left" : "keyboard_arrow_right" }}
    </mat-icon>
  </div>
</div>

<ng-template cdkPortal #unitPortal>
  @if (isUnitDropdownOpen()) {
    <app-select-modal
      [title]="'shared.profile_dropdown.change_unit_system' | translate"
      [options]="unitOptions"
      [selected]="chosenUnit() ?? selectedUnit()"
      [labelFn]="getUnitLabel.bind(this)"
      [mobile]="isMobile()"
      (optionSelect)="selectUnit($event)"
      (cancelClick)="cancelUnitSelection()"
      (saveClick)="saveUnit()"
      (backdropClick)="closeUnitModal()"
      (modalClose)="closeUnitModal()"
    />
  }
</ng-template>
